// extracted by mini-css-extract-plugin
export default {"searchCode":"SearchButton_searchCode__oygGb"};